module.exports = __webpack_public_path__ + "img/icon-arrow-up-solid.2f9d1fb2.svg";